module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.c0f1e4a4.woff2";